import cx from 'classnames';
import s from './styles.scss';
import { Size, PillVariant, ColorHue, ColorTheme } from '../../enums';

export interface Props {
  children: React.ReactNode;
  className?: string;
  color?: ColorHue | ColorTheme;
  size?: Size;
  variant?: PillVariant;
  ariaLabel?: string;
  role?: 'status' | 'tag';
}

export const Pill = ({
  children,
  className,
  color = ColorHue.BLUE,
  size = Size.MEDIUM,
  variant = PillVariant.DEFAULT,
  role,
  ariaLabel,
}: Props): JSX.Element => {
  return (
    <div
      className={cx(s.pill, s[color], s[size], s[variant], className)}
      data-test="pill"
      aria-label={ariaLabel}
      role={role}
    >
      {children}
    </div>
  );
};
